import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';

interface LoungeBottomSheetProps {}

const LoungeBottomSheet: FC<LoungeBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  const messages = [
    `국내외겸용카드를 보유한 본인 회원에 한해, 국내 공항라운지 무료 이용 가능합니다.(월 1회, 연 2회 한도)`,
    `서비스 이용월 기준 직전 3개월간 NOL · 트리플 내 해외 여행상품 100만원 이상 이용 시 제공됩니다.`,
    `서비스 이용 시 NOL 카드 실물 카드 제시 필요합니다.`,
    `서비스 이용 전 대상 공항(인천/김포) 및 대상 라운지 위치, 영업 시간 등을 확인해 주세요.`,
    `NOL · 트리플 가맹점 및 자체 간편결제 서비스(NOL 카드 페이)가 아닌 간편결제 서비스명(네이버페이 등) 또는 별도 가맹점번호로 결제되는 경우 실적 제외됩니다.\n예시) NOL에서 결제했으나 가맹점명이 '네이버 파이낸셜'인 경우`,
    `해당 서비스는 Visa및 Amex에서 제공하는 선택제공 서비스로 이용 관련 자세한 내용은 해당 브랜드사 및 현대카드 홈페이지 참고해 주세요.
      ∙ Visa 홈페이지 : www.visakorea.com
      ∙ Amex 홈페이지 : www.americanexpress.com/kr
      ∙ 현대카드 홈페이지 : www.hyundaicard.com`,
  ].filter(Boolean);

  return (
    <NolNoticeBottomSheet
      title={'공항 라운지 유의사항'}
      isOpen={store.isLoungeBottomSheetOpen}
      onRequestClose={() => (store.isLoungeBottomSheetOpen = false)}
    >
      <ul>
        {messages.map((line, key) => (
          <li key={key} style={{ whiteSpace: 'pre-line' }}>
            {line}
          </li>
        ))}
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(LoungeBottomSheet);
